import React from "react";
import { Link } from "react-router-dom";

export default function EasterPromo() {
  return (
    <div className="easter-promo" aria-label="Easter Sunday Menu">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Outfit:wght@400;600;700&display=swap');

        @keyframes bunnyHop1 {
          0%   { transform: translate(0, 0) scaleX(-1); }
          15%  { transform: translate(12vw, -30px) scaleX(-1); }
          30%  { transform: translate(24vw, 0) scaleX(-1); }
          45%  { transform: translate(36vw, -25px) scaleX(-1); }
          60%  { transform: translate(48vw, 0) scaleX(-1); }
          75%  { transform: translate(60vw, -30px) scaleX(-1); }
          90%  { transform: translate(72vw, 0) scaleX(-1); }
          100% { transform: translate(84vw, -20px) scaleX(-1); }
        }
        @keyframes bunnyHop2 {
          0%   { transform: translate(0, 0) scaleX(-1); }
          12%  { transform: translate(10vw, -22px) scaleX(-1); }
          25%  { transform: translate(20vw, 0) scaleX(-1); }
          37%  { transform: translate(30vw, -28px) scaleX(-1); }
          50%  { transform: translate(40vw, 0) scaleX(-1); }
          62%  { transform: translate(50vw, -22px) scaleX(-1); }
          75%  { transform: translate(60vw, 0) scaleX(-1); }
          87%  { transform: translate(70vw, -26px) scaleX(-1); }
          100% { transform: translate(80vw, 0) scaleX(-1); }
        }
        @keyframes bunnyHop3 {
          0%   { transform: translate(0, 0); }
          14%  { transform: translate(-11vw, -18px); }
          28%  { transform: translate(-22vw, 0); }
          42%  { transform: translate(-33vw, -24px); }
          56%  { transform: translate(-44vw, 0); }
          70%  { transform: translate(-55vw, -18px); }
          84%  { transform: translate(-66vw, 0); }
          100% { transform: translate(-77vw, -20px); }
        }

        @keyframes sway {
          0%, 100% { transform: rotate(-3deg); }
          50%      { transform: rotate(3deg); }
        }

        .easter-promo {
          --ep-pink: #e8a0b4;
          --ep-pink-light: #f5d5df;
          --ep-cream: #fdf8f0;
          --ep-gold: #8a7a3a;
          --ep-gold-light: #c4a94e;
          --ep-green: #5a7a3a;
          --ep-green-light: #8aaa5a;
          --ep-text: #4a3a2a;

          position: relative;
          width: 100%;
          min-height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: repeating-linear-gradient(
            90deg,
            #fce8ef 0px,
            #fce8ef 28px,
            #fff5f8 28px,
            #fff5f8 56px
          );
          overflow: hidden;
          font-family: 'Outfit', sans-serif;
        }

        .easter-promo__border {
          position: relative;
          z-index: 2;
          border: 3px solid var(--ep-gold);
          outline: 1px solid var(--ep-gold-light);
          outline-offset: 6px;
          background: rgba(253, 248, 240, 0.92);
          padding: 2.5rem 2.5rem 1.5rem;
          max-width: 580px;
          width: 85%;
          text-align: center;
        }

        .easter-promo__bunny-icon {
          display: block;
          margin: 0 auto 0.25rem;
          font-size: 2.2rem;
          color: var(--ep-gold);
          line-height: 1;
        }

        .easter-promo__title {
          font-family: 'Great Vibes', cursive;
          font-size: 3.2rem;
          color: var(--ep-gold);
          margin: 0 0 0.75rem;
          line-height: 1.1;
        }

        .easter-promo__subtitle {
          font-size: 1.05rem;
          font-weight: 600;
          color: var(--ep-text);
          text-transform: uppercase;
          letter-spacing: 2px;
          margin: 0 0 0.5rem;
        }

        .easter-promo__date {
          font-size: 1.15rem;
          font-weight: 700;
          color: var(--ep-gold);
          margin: 0 0 1rem;
          letter-spacing: 1px;
        }

        .easter-promo__items {
          list-style: none;
          padding: 0;
          margin: 0 0 1.25rem;
        }

        .easter-promo__items li {
          font-size: 1rem;
          font-weight: 600;
          color: var(--ep-text);
          padding: 0.2rem 0;
          letter-spacing: 0.5px;
        }

        .easter-promo__note {
          font-size: 0.95rem;
          color: var(--ep-text);
          opacity: 0.8;
          font-style: italic;
          margin: 0 0 1.5rem;
        }

        .easter-promo__cta-group {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.75rem;
        }

        .easter-promo__cta,
        .easter-promo__cta:visited,
        .easter-promo__cta:active {
          display: inline-block;
          background: var(--ep-green);
          color: var(--ep-cream) !important;
          padding: 0.8rem 2rem;
          border-radius: 6px;
          font-weight: 700;
          font-size: 1rem;
          text-transform: uppercase;
          letter-spacing: 2px;
          text-decoration: none;
          border: 2px solid var(--ep-gold);
          transition: background 200ms ease, transform 150ms ease;
        }

        .easter-promo__cta:hover {
          background: var(--ep-green-light);
          color: var(--ep-cream) !important;
          transform: scale(1.04);
        }

        .easter-promo__menu-link,
        .easter-promo__menu-link:visited,
        .easter-promo__menu-link:active {
          display: inline-block;
          color: var(--ep-gold) !important;
          font-weight: 600;
          font-size: 0.95rem;
          text-decoration: underline;
          text-underline-offset: 3px;
          transition: color 200ms ease;
        }

        .easter-promo__menu-link:hover {
          color: var(--ep-green) !important;
        }

        /* Daffodils */
        .easter-promo__flowers {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 90px;
          z-index: 1;
          display: flex;
          justify-content: center;
          gap: 1rem;
          pointer-events: none;
          overflow: hidden;
        }

        .easter-promo__flower {
          font-size: 2.8rem;
          animation: sway 3s ease-in-out infinite;
          filter: drop-shadow(0 2px 3px rgba(0,0,0,0.1));
          align-self: flex-end;
          padding-bottom: 4px;
        }
        .easter-promo__flower:nth-child(2n) { animation-delay: 0.5s; }
        .easter-promo__flower:nth-child(3n) { animation-delay: 1s; font-size: 2.4rem; }
        .easter-promo__flower:nth-child(5n) { animation-delay: 1.5s; font-size: 3rem; }

        /* Hopping bunnies */
        .easter-promo__bunnies {
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: 3;
          overflow: hidden;
        }

        .easter-promo__bunny {
          position: absolute;
          font-size: 1.8rem;
          opacity: 0.55;
          filter: drop-shadow(0 2px 2px rgba(0,0,0,0.1));
        }

        .easter-promo__bunny--1 {
          bottom: 12%;
          left: -5%;
          animation: bunnyHop1 14s linear infinite;
        }
        .easter-promo__bunny--2 {
          bottom: 22%;
          left: -8%;
          font-size: 1.4rem;
          opacity: 0.35;
          animation: bunnyHop2 18s linear infinite 3s;
        }
        .easter-promo__bunny--3 {
          top: 10%;
          right: -5%;
          font-size: 1.5rem;
          opacity: 0.4;
          animation: bunnyHop3 16s linear infinite 1s;
        }
        .easter-promo__bunny--4 {
          bottom: 35%;
          left: -3%;
          font-size: 1.2rem;
          opacity: 0.3;
          animation: bunnyHop1 20s linear infinite 7s;
        }
        .easter-promo__bunny--5 {
          top: 25%;
          right: -4%;
          font-size: 1.6rem;
          opacity: 0.35;
          animation: bunnyHop3 15s linear infinite 5s;
        }

        @media (max-width: 600px) {
          .easter-promo {
            min-height: 420px;
          }
          .easter-promo__border {
            padding: 1.5rem 1.25rem 1rem;
            width: 90%;
          }
          .easter-promo__title {
            font-size: 2.2rem;
          }
          .easter-promo__subtitle {
            font-size: 0.85rem;
          }
          .easter-promo__items li {
            font-size: 0.88rem;
          }
          .easter-promo__cta {
            padding: 0.65rem 1.5rem;
            font-size: 0.88rem;
          }
          .easter-promo__flowers {
            height: 65px;
          }
          .easter-promo__flower {
            font-size: 2rem;
          }
        }
      `}</style>

      <div className="easter-promo__bunnies" aria-hidden="true">
        <span className="easter-promo__bunny easter-promo__bunny--1">🐇</span>
        <span className="easter-promo__bunny easter-promo__bunny--2">🐇</span>
        <span className="easter-promo__bunny easter-promo__bunny--3">🐇</span>
        <span className="easter-promo__bunny easter-promo__bunny--4">🐇</span>
        <span className="easter-promo__bunny easter-promo__bunny--5">🐇</span>
      </div>

      <div className="easter-promo__border">
        <span className="easter-promo__bunny-icon" aria-hidden="true">🐰</span>
        <h2 className="easter-promo__title">Easter Sunday Menu</h2>
        <p className="easter-promo__subtitle">Sunday, April 5th</p>
        <p className="easter-promo__date">Available to Order on the Day Of</p>

        <ul className="easter-promo__items">
          <li>Slow Roasted Turkey — $27.99</li>
          <li>Prime Rib Plate — $29.99</li>
          <li>Honey Glazed Ham — $26.99</li>
        </ul>

        <p className="easter-promo__note">
          Served with soup or salad, choice of potato, vegetable &amp; cornbread with butter.
        </p>

        <div className="easter-promo__cta-group">
          <Link to="/burbank/order" className="easter-promo__cta">
            Order Online
          </Link>
          <a
            href="/lancers-easter-2026.jpeg"
            target="_blank"
            rel="noopener noreferrer"
            className="easter-promo__menu-link"
          >
            View Easter Menu
          </a>
        </div>
      </div>

      <div className="easter-promo__flowers" aria-hidden="true">
        <span className="easter-promo__flower">🌼</span>
        <span className="easter-promo__flower">🌷</span>
        <span className="easter-promo__flower">🌼</span>
        <span className="easter-promo__flower">🌷</span>
        <span className="easter-promo__flower">🌼</span>
        <span className="easter-promo__flower">🌷</span>
        <span className="easter-promo__flower">🌼</span>
        <span className="easter-promo__flower">🌷</span>
        <span className="easter-promo__flower">🌼</span>
      </div>
    </div>
  );
}
